var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20 497.33C12 497.33 6.67 492 6.67 484C6.67 437.6 6.67 66.4 6.67 20C6.67 12 12 6.67 20 6.67C80 6.67 560 6.67 620 6.67C628 6.67 633.33 12 633.33 20C633.33 66.4 633.33 437.6 633.33 484C633.33 490.67 628 497.33 620 497.33C500 497.33 80 497.33 20 497.33ZM606.67 470.67L606.67 33.33L33.33 33.33L33.33 470.67L606.67 470.67Z",
    id: "a1zzOgNCks"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.33 633.33C458.67 633.33 181.33 633.33 146.67 633.33C142.67 633.33 137.33 630.67 136 626.67C133.33 622.67 133.33 617.33 134.67 613.33C141.33 599.73 194.67 490.93 201.33 477.33C204 473.33 208 469.33 213.33 469.33C234.67 469.33 405.33 469.33 426.67 469.33C432 469.33 436 472 438.67 477.33C445.2 490.8 497.47 598.53 504 612C505.33 614.67 506.67 617.33 506.67 620C506.67 628 501.33 633.33 493.33 633.33C493.33 633.33 493.33 633.33 493.33 633.33ZM472 606.67L418.67 497.33L221.33 497.33L168 606.67L472 606.67Z",
    id: "hItFGaFcf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.67 388C214.67 385.33 212 381.33 212 376C212 351.07 212 151.6 212 126.67C212 121.33 214.67 117.33 218.67 114.67C222.67 112 228 112 232 114.67C251.07 127.2 403.6 227.47 422.67 240C426.67 242.67 429.33 246.67 429.33 250.67C429.33 254.67 426.67 260 422.67 261.33C403.73 273.73 252.27 372.93 233.33 385.33C230.67 389.33 228 389.33 225.33 389.33C222.67 389.33 221.33 389.33 218.67 388ZM238.67 352L390.67 252L238.67 152L238.67 352Z",
    id: "e1oIGvbNf"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1zzOgNCks",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1zzOgNCks",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hItFGaFcf",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hItFGaFcf",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e1oIGvbNf",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e1oIGvbNf",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon3);
export default __webpack_public_path__ + "static/media/info-icon-3.b2b4defa85182b0f125496c7309bae6b.svg";
export { ForwardRef as ReactComponent };